"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isImage;
/**
 * detect the file is image
 *
 * @param fileType
 * @returns {boolean}
 */
function isImage(fileType) {
  var imageType = /image.*/;

  return !!fileType.match(imageType);
}